import { InterpolationWithTheme } from './isolateComponent';

// Number of selectors to chain together for resetting styles.
// This is used to unset external styles that would typically
// affect our component styles.
const stylesResetSpecificity = 4;

// Number of selectors to chain together for applying component
// styles. This *must be* greater than `stylesResetSpecificity`, and
// it should only need to be greater by 1.
const componentSpecificity = stylesResetSpecificity + 1;

// Selector for component styles. Repeats `[class]` which will
// increase specificity, concatenated onto `&`, which `emotion`
// will transform into a CSS class name.
const componentSelector = '&' + '[class]'.repeat(componentSpecificity);

// type CssPropertiesBuilder =
//   | React.CSSProperties
//   | (() => React.CSSProperties)
//   | (React.CSSProperties | (() => React.CSSProperties))[];

// Returns an object with a selector specific enough to
// override (essentially) any external styles that may
// conflict with the component's own styles. This selector
// is one level more specific than an `all: unset` selector,
// which resets all external styles, thereby allowing this
// more specific selector to define component-specific styles.
export const isolateCss = (styles: InterpolationWithTheme<any>): any => {
  return Array.isArray(styles)
    ? styles.map(isolateCss)
    : {
        [componentSelector]: styles,
      };
};
export const stylesResetAttribute = 'data-css-reset';

// Selector for component reset styles. Repeats this attribute
// selector, which is a substring of the CSS class that `emotion`
// applies to all components.
export const stylesResetSelector = `[${stylesResetAttribute}]`.repeat(
  stylesResetSpecificity
);
